/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignPipelineConfigUpdate } from '../../axios/campaignPipelineConfigUpdate'
import type {
	CampaignPipelineConfigUpdateError,
	CampaignPipelineConfigUpdatePathParams,
	CampaignPipelineConfigUpdateRequest,
	CampaignPipelineConfigUpdateResponse,
} from '../../types/CampaignPipelineConfigUpdate'

export const campaignPipelineConfigUpdateMutationKey = () => [{ url: '/campaigns/:campaign/pipeline-config' }] as const

export type CampaignPipelineConfigUpdateMutationKey = ReturnType<typeof campaignPipelineConfigUpdateMutationKey>

export type CampaignPipelineConfigUpdateVariables = {
	campaign: CampaignPipelineConfigUpdatePathParams['campaign']
	data: CampaignPipelineConfigUpdateRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignPipelineConfigController.php CampaignPipelineConfigController::update */
export function useCampaignPipelineConfigUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignPipelineConfigUpdateResponse,
		AxiosError<CampaignPipelineConfigUpdateError>,
		CampaignPipelineConfigUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignPipelineConfigUpdateMutationKey(),
		mutationFn: ({ campaign, data }: CampaignPipelineConfigUpdateVariables) =>
			campaignPipelineConfigUpdate(campaign, data, config).then(res => res.data),
		...options,
	})
}
